export const Spinner = ({ loadingText, color }) => (
  <div className="d-flex justify-content-center align-items-center">
    <div style={{ color }} className="spinner-border" role="status" />
    <span className="h4 ps-2">{loadingText}</span>
  </div>
)
